import {writable} from 'svelte/store';

const state = {code: '', data: {}};
const trigger = writable(state);

trigger.event = (code, data) => {
	state.code = code;
	state.data = data;
	trigger.set(state);
};

trigger.is = (data, code) => {
	return data.code === code;
};

export default trigger;